import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import RaiseClaim from "./raiseClaim";
import ModifyClaim from "./modifyClaim";
import UnclaimedFilter from "./unclaimedFilter";
// import AddCarnivalPopup from "./addCarnivalPopup";

const UnclaimedTransactionList = ({
                            fetchUnclaimedList = null,
                            unclaimedTransLists = null,
                            match,
                            history,
                            verifyInvoicesNumbers,
  verifyInvoiceNumbersWithRecon=[],
  editClientDetails,
  editClientDetailsForTan=[],
  documentUploadUrlPublic,
  documentUrlDataPublic=[]
                          }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
  const [carnivalId, setCarnivalId] = useState('');
  const [changeStatus, setChangeStatus] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [showRaisePopup, setShowRaisePopup] = useState(false);
  const [paymentReference, setPaymentReference] = useState('');
  const [modeOfCollection, setModeOfCollection] = useState('');
  const [unclaimedAmount, setUnclaimedAmount] = useState('');
  const [businessList, setBusinessList] = useState('');
  const [unclaimedId, setUnclaimedId] = useState();

  const Headers = [
    'Transaction Id',
    'Payment Reference',
    'Transaction Date',
    'Mode of Collection',
    'Description',
    'Transaction Amount',
    'Unclaimed Amount',
    'Status',
    'Eligible for Modification',
    'Actions',
  ];

  useEffect(() => {
    if (fetchUnclaimedList !== null)
      (async () => {
        setIsLoading(true);
        await fetchUnclaimedList();
        setIsLoading(false);
      })();
  }, [fetchUnclaimedList]);

  useEffect(() => {
    const tableData = [
      'id',
      'transaction_id',
      'payment_reference',
      'transaction_date',
      'mode_of_collection',
      'description',
      'transaction_amount',
      'unclaimed_amount',
      'status',
      'eligibile_for_modification'
    ];

    const data =
    unclaimedTransLists?.resultSets?.length &&
    unclaimedTransLists.resultSets.map((element) => {
      let actions = [];

      if (element.unclaimed_amount <= 0) {
        actions.push({
          name: 'View Claim',
          link: `${baseUrl}/view-raised-claim/${element.payment_reference}/${element?.id}`,
        });
      } else {
        actions.push({
          name: 'Raise Claim',
          PaymentRef: element.payment_reference,
          mode_of_collection: element.mode_of_collection,
          unclaimed_amount: element.unclaimed_amount,
        });

        actions.push({
          name: 'View Claim',
          link: `${baseUrl}/view-raised-claim/${element.payment_reference}/${element?.id}`,
        });
      }

      if (element.status === 'REJECTED') {
        actions.push({
          name: 'Modify Claim',
          PaymentRef: element.payment_reference,
        });
      }
      return Object.assign(
        {},
        ...tableData.map((key) => (
          (key == 'eligibile_for_modification') ? (element[key]==false?{ [key]: 'No' } :{ [key]: 'Yes' }):
          { [key]: element[key] })),
        { Action: actions }
      );
    });

    // console.log(tableData);
    if (unclaimedTransLists?.resultSets?.length && data) {
      setListData(data);
      setPageCount(Math.ceil(unclaimedTransLists.total / unclaimedTransLists.per_page));
    } else {
      setListData([]);
    }
    if (unclaimedTransLists?.business_list?.length) {
      setBusinessList(unclaimedTransLists?.business_list);
    }
  }, [unclaimedTransLists, baseUrl]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setPageNumber(val.selected + 1);
    setIsLoading(true);
    await fetchUnclaimedList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    // console.log(filterData);return;
    setIsLoading(true);
    setFilterData(filterData);
    await fetchUnclaimedList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };


  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          {/* <img src={Images?.Filter} alt="" /> */}
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.UnclaimedTransaction}
      Buttons={headerBtns}
      isLoading={isLoading}
      linkFlag
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={unclaimedTransLists?.resultSets}
        isId={false}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={unclaimedTransLists?.from}
        setShowRaisePopup={setShowRaisePopup}
        setPaymentReference={setPaymentReference}
        setModeOfCollection={setModeOfCollection}
        setUnclaimedAmount={setUnclaimedAmount}
        dontAppendLink = {true}
        currentPage = {unclaimedTransLists?.current_page}
        setUnclaimedId={setUnclaimedId}
      />

      <UnclaimedFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
      />

      <RaiseClaim
        showRaisePopup={showRaisePopup}
        onClosePopup={() => setShowRaisePopup(false)}
        businessList={businessList}
        paymentReference={paymentReference}
        modeOfCollection={modeOfCollection}
        unclaimedAmount={unclaimedAmount}
        unclaimedId={unclaimedId}
        verifyInvoiceNumbers={verifyInvoicesNumbers}
        verifyInvoiceNumbersWithRecon={verifyInvoiceNumbersWithRecon}
        editClientDetails={editClientDetails}
        documentUploadUrlPublic={documentUploadUrlPublic}
        documentUrlDataPublic={documentUrlDataPublic}
      />
    </Layout>
  );
};

UnclaimedTransactionList.propTypes = {
  unclaimedTransLists: PropTypes.any,
  fetchUnclaimedList: PropTypes.func,
  match: PropTypes.any,
};

export default UnclaimedTransactionList;


